module.exports = __webpack_public_path__ + "static/bnr_square-0d3a49f381cc70ecb4dd10351397a554.webp";